import React from "react";

function Membership() {
  return (
    <>
      <div className="container two-column">
        <div>
          <h2 className="section-title">Membership Fees (2026)</h2>
          <p><strong>Annual Membership:</strong> $60</p>
          <p><strong>Session Fee:</strong> $10 per session (includes shuttles)</p>
          <p className="muted">
            Fees are based on actual club expenses and help keep badminton accessible for everyone.
          </p>
        </div>
        <div>
          <h3>What Your Membership Supports</h3>
          <ul className="bullet-list">
            <li>Insurance coverage through Badminton NSW affiliation</li>
            <li>Discounted session fees (members pay $10 instead of $15)</li>
            <li>Court hire and high‑quality shuttlecocks</li>
            <li>All funds reinvested into the club — fully volunteer‑run and not‑for‑profit</li>
          </ul>
        </div>
      </div>

      <div className="container section-spaced">
        <h3>Member Benefits</h3>
        <div className="card-grid card-grid-3">
          <article className="card">
            <h4>Priority Booking</h4>
            <p>Reserve your spot at social sessions before casual players.</p>
          </article>
          <article className="card">
            <h4>Discounted Fees</h4>
            <p>Lower session fees for members all year round.</p>
          </article>
          <article className="card">
            <h4>Club‑Exclusive Events</h4>
            <p>Access to competitions, events, and development opportunities.</p>
          </article>
          <article className="card">
            <h4>Badminton NSW Affiliation</h4>
            <p>Insurance and connection to the wider badminton community.</p>
          </article>
        </div>
      </div>

      <div className="container section-spaced">
        <h3>How to Join BBI</h3>
        <ol className="steps-list">
          <li>
            Download the
            <a href="/BBI membership Form - 2026.pdf" download style={{ margin: '0 0.5rem'}}>
              Membership Application Form
            </a>,
            <a href="/Code%20of%20Conduct%20%26%20Waiver%20Agreement%202026.pdf" download style={{ margin: '0 0.5rem'}}>
              Code of Conduct & Waiver Agreement
            </a>
          </li>
          <li>Email your completed forms to <a href="mailto:beyondbaddy@gmail.com">beyondbaddy@gmail.com</a>.</li>
          <li>Once approved, you’ll receive PayID details to complete payment.</li>
          <li>After payment is confirmed, your 2026 BBI membership will be activated.</li>
        </ol>
        <a href="mailto:beyondbaddy@gmail.com" className="btn btn-primary">
          Contact for Membership Enquiries
        </a>
      </div>
    </>
  );
}

export default Membership;
